import { useState } from "react"

import { Modal } from "./Modal"

type ConfirmDeleteModalProps = {
  errorMessage: string
  message: string
  onClose: () => void
  onConfirm: () => Promise<void>
  title: string
}

export function ConfirmDeleteModal({
  errorMessage,
  message,
  onClose,
  onConfirm,
  title,
}: ConfirmDeleteModalProps) {
  const [error, setError] = useState(false)
  const [isDeleting, setIsDeleting] = useState(false)

  function close() {
    if (isDeleting) return

    onClose()
  }

  async function confirm() {
    if (isDeleting) return

    setError(false)
    setIsDeleting(true)

    try {
      await onConfirm()
      onClose()
    } catch {
      setError(true)
    } finally {
      setIsDeleting(false)
    }
  }

  return (
    <Modal
      footer={(
        <>
          <button
            className="h-8 rounded-[4px] border border-[#344149] bg-white px-3 text-xs font-medium leading-4 text-[#344149] hover:bg-[#f5f5f5] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#337ab7] focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
            disabled={isDeleting}
            onClick={close}
            type="button"
          >
            Cancel
          </button>
          <button
            className="h-8 rounded-[4px] bg-[#344149] px-3 text-xs font-medium leading-4 text-white hover:bg-[#263138] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#337ab7] focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
            disabled={isDeleting}
            onClick={() => void confirm()}
            type="button"
          >
            {isDeleting ? "Deleting" : "Delete"}
          </button>
        </>
      )}
      onClose={close}
      open
      title={title}
    >
      {error ? (
        <p className="rounded-[4px] border border-[#e0b4b4] bg-[#fff2f2] px-3 py-2 text-sm font-bold text-[#873230]">
          {errorMessage}
        </p>
      ) : null}
      <p>{message}</p>
    </Modal>
  )
}
